export default __webpack_public_path__ + "static/media/video.7c94d143.svg";